module.exports = __webpack_public_path__ + "static/media/Franklin-Palmer-covenants.2150e11d.pdf";